import React from 'react';
import Button from '../Button';

export interface ReelDeleteConfirmModalProps {
  show: boolean;
  loading?: boolean;
  error?: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Confirmation dialog before deleting a gönderi/reel.
 */
const ReelDeleteConfirmModal: React.FC<ReelDeleteConfirmModalProps> = ({
  show,
  loading = false,
  error = null,
  onConfirm,
  onCancel,
}) => {
  if (!show) return null;

  return (
    <>
      <div
        className="modal fade show"
        style={{ display: 'block' }}
        tabIndex={-1}
        aria-modal="true"
        role="dialog"
        aria-labelledby="reel-delete-modal-title"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0 pb-0">
              <h5 className="modal-title" id="reel-delete-modal-title">
                Gönderiyi sil
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={onCancel}
                disabled={loading}
                aria-label="Kapat"
              />
            </div>
            <div className="modal-body text-center pt-2">
              <div className="text-danger mb-3">
                <i className="fas fa-trash-alt" style={{ fontSize: '3rem' }} aria-hidden="true" />
              </div>
              <p className="mb-2">Bu gönderiyi silmek istediğine emin misin?</p>
              <p className="text-muted small mb-0">Bu işlem geri alınamaz.</p>
              {error && (
                <div className="alert alert-danger small mt-3 mb-0" role="alert">
                  {error}
                </div>
              )}
            </div>
            <div className="modal-footer border-0 justify-content-center pb-4">
              <Button
                type="button"
                className="btn btn-outline-secondary"
                onClick={onCancel}
                disabled={loading}
              >
                Vazgeç
              </Button>
              <Button
                type="button"
                className="btn btn-danger ms-2"
                onClick={onConfirm}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                    Siliniyor…
                  </>
                ) : (
                  'Sil'
                )}
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" />
    </>
  );
};

export default ReelDeleteConfirmModal;
